import { isValid, parse, parseISO } from 'date-fns';

// The software-catalogue writes the `neo4j/last-docs-update` annotation with
// the Go `time.Time` string format, for example
// `2025-06-16 10:04:51 +0000 UTC`. Only some browsers parse that format with
// `new Date()`, so it is parsed here with date-fns.
const GO_TIME_FORMAT = "yyyy-MM-dd HH:mm:ss xxxx 'UTC'";

/**
 * Returns the date of a `neo4j/last-docs-update` annotation, or `undefined`
 * when the value is missing or has an unknown format.
 */
export function parseDocsUpdateDate(value?: string): Date | undefined {
  if (!value) {
    return undefined;
  }

  const isoDate = parseISO(value);
  if (isValid(isoDate)) {
    return isoDate;
  }

  const goDate = parse(value, GO_TIME_FORMAT, new Date());
  return isValid(goDate) ? goDate : undefined;
}
